/*
 * Podio Dropdown
 * Version 1.0
 * Written by: Kenneth Auchenberg
 *
 */

/* Integration instructions:
 - You should avoid using overflow: hidden on parent elements otherwise they cut off the dropdown-menu. Use @include clearfix; instead
 - If you want to set custom width on the element set it to the "podio-dropdown" class
 */

define('lib/jquery/jquery.podioDropdown',['require','translate','underscore','jquery','lib/jquery/jquery.getscrollbarwidth'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.getscrollbarwidth');

  var getDefaultSettings = function() {

    return {
      showAllLabel : t('All'),
      singleAllOptionValue : '::all::',
      indentGroupItems: false,
      isDisabled: false,
      classes : {
        disabled: 'disabled',
        masterToggle : 'master-toggle',
        podioControlIcon: 'podio-dropdown-icon',
        item: 'podio-dropdown-item',
        itemActive : 'active',
        matchTextFieldHeight: 'match-textfield-height'
      },
      events : {
        hide: 'hide.dropdown.podio',
        _internal_forceHide: 'forceHide.dropdown.podio', // internal event
        show: 'show.dropdown.podio',
        change: 'change.dropdown.podio',        /* deprecated, since it is not capable of returning multiple selected values */
        changeV2: 'changeV2.dropdown.podio',
        changedItem: 'changedItem.dropdown.podio',
        customClick: 'custom.click.dropdown.podio',
        refresh : 'refresh.dropdown.podio',
        disable : 'disable.dropdown.podio',
        enable : 'enable.dropdown.podio',
        forceShow: 'forceShow.dropdown.podio',
        destroy: 'destroy.dropdown.podio'
      },
      itemModes : {
        master: 'master',
        custom: 'custom'
      }
    };

  };

  $.podioDropdown = function (input) {
    var settings, exports;
    var KEY = { BACKSPACE: 8, TAB: 9, RETURN: 13, ESC: 27, LEFT: 37, UP: 38, RIGHT: 39, DOWN: 40, COMMA: 188, SPACE: 32 }; // Keys "enum"
    var elmHiddenInput, elmDropWrapper, elmDropContainer, elmControlWrapper, elmControlContainer;
    var scrollbarWidth;
    var hasAdjustedLabelWidth = false;
    var hasAdjustedDropdownHeight = false;
    var elmSelectedDropdownItem;

    function init(options) {
      settings = options;
      elmHiddenInput = $(input).hide();


      if (elmHiddenInput.attr('data-podio-dropdown') == 'true') {
        return;
      }

      elmHiddenInput.attr('data-podio-dropdown', 'true');

      if (!scrollbarWidth) {
        scrollbarWidth = $.getScrollbarWidth();

        if (scrollbarWidth > 0) {
          scrollbarWidth--;
        }
      }

      settings.isMultiple = !_.isUndefined(elmHiddenInput.attr("multiple"));

      elmControlWrapper = renderBasicControl(); // append the control that resembles a single selection select
      elmControlContainer = elmControlWrapper.find('.podio-dropdown-selector');
      elmDropWrapper = renderDropContainer(); // create the drop container where the items are shown

      // bind to event, to allow other dropdowns to hide, force a refresh, etc
      elmDropWrapper.bind(settings.events._internal_forceHide, hideDropdown);
      elmControlContainer.bind('focus', onControlContainerFocus);
      elmControlContainer.bind('blur', onControlContainerBlur);
      elmControlContainer.bind('keydown', onControlContainerKeyDown);
      elmHiddenInput.bind(settings.events.refresh, onRefreshEvent);
      elmHiddenInput.bind(settings.events.enable, onEnableEvent);
      elmHiddenInput.bind(settings.events.disable, onDisableEvent);
      elmHiddenInput.bind(settings.events.forceShow, onForceShowEvent);
      elmHiddenInput.bind(settings.events.destroy, onDestroyEvent);

      renderDropdownItems(); // append the items from the source select element

      syncDropdownToInput();  // look for possible auto-check needed on first item

      updateControlText(); // updates the text shown in the control

      updateControlIcon(); // Update the icon if needed

      // Events
      elmControlWrapper.click(function(e) {
        if (elmControlWrapper.hasClass('disabled')) {
          return;
        }

        e.stopImmediatePropagation();
        showDropdown();
      });

      elmDropContainer.delegate('div.podio-dropdown-item label', 'click', function(e) {

        e.preventDefault();

        // Emulates label click behaviour manually
        var elmInput = $(e.target).siblings('input');
        var isChecked = elmInput.prop('checked');
        // not inverting the check property if single select and clicking on the same element twice
        if (settings.isMultiple || !isChecked) {
          elmInput.prop('checked', !isChecked);
        }
        elmInput.trigger('change');

      });

      elmDropContainer.delegate('input', 'change', _.debounce(onCheckboxChange, 100));

      return elmHiddenInput;
    }

    // Custom events
    function onDisableEvent() {
      elmControlWrapper.addClass(settings.classes.disabled);
      elmHiddenInput.val('');
      elmHiddenInput.trigger(settings.events.refresh);
    }

    function onEnableEvent() {
      elmControlWrapper.removeClass(settings.classes.disabled);
      elmHiddenInput.trigger(settings.events.refresh);
    }

    function onRefreshEvent() {
      syncInputToDropdown();
      updateControlText();
      updateControlIcon();
    }

    function onDestroyEvent() {
      $.removeData(elmHiddenInput[0], 'podioDropdown');
      elmHiddenInput.removeAttr('data-podio-dropdown', 'true');

      elmControlWrapper.remove();
      elmControlContainer.remove();
      elmDropWrapper.remove();
    }

    function onForceShowEvent() {
      showDropdown();
    }

    // Regular events

    function onControlContainerFocus(e) {
      var elmControlWrapper = $(e.target).parent();
      if (elmControlWrapper.hasClass('disabled')) {
        return;
      }
      showDropdown();
      selectCurrentDropdownItem();
    }

    function onControlContainerBlur(e) {
      resetCurrentDropdownItem();
    }

    function onControlContainerKeyDown(e) {
      switch (e.keyCode) {
        case KEY.UP:
        case KEY.DOWN:
          if (!elmSelectedDropdownItem || !elmSelectedDropdownItem.length) {
            elmSelectedDropdownItem = elmDropContainer.find('.' + settings.classes.item).first();
          }
          if (e.keyCode == KEY.DOWN) {
            var elmNextDropDownItem = elmSelectedDropdownItem.next('.' + settings.classes.item);
            if (elmNextDropDownItem.length > 0) {
              elmSelectedDropdownItem = elmNextDropDownItem;
            }
          } else {
            var elmPrevDropDownItem = elmSelectedDropdownItem.prev('.' + settings.classes.item);
            if (elmPrevDropDownItem.length > 0) {
              elmSelectedDropdownItem = elmPrevDropDownItem;
            }
          }

          if (elmSelectedDropdownItem.length) {
            elmSelectedDropdownItem.addClass(settings.classes.itemActive);
            elmSelectedDropdownItem.siblings().removeClass(settings.classes.itemActive);
          }
          return false;

        case KEY.RETURN:
        case KEY.COMMA:
        case KEY.TAB:
        case KEY.SPACE:

          var elmInput = elmSelectedDropdownItem.find('input');
          elmInput.prop('checked', true); // Checked attribute is not being updated in Firefox when emulating click event.
          elmInput.trigger('change');

          break;

        case KEY.ESC:
          hideDropdown();
          return true;

      }
    }

    function onCheckboxChange(e) {
      var elmListItem = $(e.target).parents('.' + settings.classes.item);

      if (elmListItem.data('mode') === settings.itemModes.custom) {
        elmHiddenInput.trigger(settings.events.customClick, { id: elmListItem.data('id')});
        hideDropdown();
        e.stopImmediatePropagation();
        return false;
      }

      handleMasterState($(e.target));

      syncDropdownToInput();

      updateControlText();

      updateControlIcon();

      elmHiddenInput.trigger(settings.events.change, elmHiddenInput.val());
      elmHiddenInput.trigger(settings.events.changeV2, { values: elmHiddenInput.val() });

      if (!$(e.target).hasClass(settings.itemModes.custom) && !$(e.target).hasClass(settings.itemModes.master)) {
        elmHiddenInput.trigger(settings.events.changedItem, $(e.target).val(), settings.isMultiple ? $(e.target).is(':checked') : true, $(e.target).data());
      }

      if (!settings.isMultiple) {
        hideDropdown();
      }
    }

    function handleMasterState(elmTarget) {

      if (!settings.showAllOption) {
        return;
      }

      var elmInputCollection = elmDropContainer.find('input');

      if (elmTarget) {
        var isChecked = elmTarget.prop('checked');
        if (elmTarget.hasClass(settings.itemModes.master)) {
          if (isChecked) {
            elmInputCollection.not(elmTarget).prop('checked', false);
            triggerDeselectEventsOnAll(elmInputCollection.not(elmTarget));
          } else {
            elmTarget.prop('checked', true);
          }
        } else {
          elmDropContainer.find('.' + settings.itemModes.master).prop('checked', false);
        }
      }

      if (elmInputCollection.filter(':checked').length === 0) {
        elmDropContainer.find('.' + settings.itemModes.master).prop('checked', true);
        elmControlWrapper.removeClass('value-set');
      } else if (elmInputCollection.not('.' + settings.itemModes.master).filter(':checked').length) {
        // if we have a checked value after it has been set, uncheck the master
        elmInputCollection.filter('.' + settings.itemModes.master).prop('checked', false);
        elmControlWrapper.addClass('value-set');
      } else {
        elmControlWrapper.removeClass('value-set');
      }

    }

    function triggerDeselectEventsOnAll(elmInputCollection) {
      elmInputCollection.each(function() {
        elmHiddenInput.trigger(settings.events.changedItem, $(this).val(), false, $(this).data());
      });
    }

    function renderBasicControl() {
      var elmWrapper = $("<div class=\"podio-dropdown podio-dropdown-selector-wrapper\" />");
      if(settings.classes.wrapper) {
        elmWrapper.addClass(settings.classes.wrapper);
      }

      // assign an ID
      var defaultId = elmHiddenInput.attr("id");
      var baseId = (defaultId === "") ? "podiodropdown-" + settings.dropdownId : "podiodropdown-" + defaultId;
      elmWrapper.attr("id", baseId);

      var elmContainer = $("<div/>", { 'class' : "podio-dropdown-selector podio-dropdown-state-default" });
      elmContainer.css({ overflow: "hidden" });

      // Setting a tab index means we are interested in the tab sequence
      var tabIndex = elmHiddenInput.attr("tabIndex");
      if (!tabIndex) {
        tabIndex = 0;
      } else {
        tabIndex = parseInt(tabIndex, 10);
        if (tabIndex < 0) {
          tabIndex = 0;
        }
      }
      elmContainer.attr("tabIndex", tabIndex);

      if (settings.isDisabled) {
        elmWrapper.addClass(settings.classes.disabled);
      }

      elmWrapper.append(elmContainer);

      // we need a sensible default for the arrow width, if scrollbars are hidden on Mac OS for instance
      var arrowWidth = scrollbarWidth || 16;
      var elmArrow = $('<div />', { 'class' : 'arrow', width: arrowWidth });
      elmContainer.prepend(elmArrow);

      var elmTextContainer = $("<div/>", { 'class': "podio-dropdown-text" });
      elmContainer.append(elmTextContainer);

      var commonWrapper = $('<div class="podio-dropdown podio-dropdown-common-wrapper" />').append(elmWrapper);
      if (settings.matchTextFieldHeight) {
        commonWrapper.addClass(settings.classes.matchTextFieldHeight);
      }
      commonWrapper.insertAfter(elmHiddenInput);

      return elmWrapper;
    }

    function renderDropContainer() {
      var elmScrollbar = $('<div  />', { 'class' : 'scrollbar-overlay', width: scrollbarWidth });
      elmDropContainer = $("<div />", { 'class' : 'podio-dropdown-dropcontainer'});
      elmDropContainer.append(elmScrollbar);

      if (settings.indentGroupItems) {
        elmDropContainer.addClass('indent-group-items');
      }

      var elmWrapper = $("<div/>", { 'class': 'podio-dropdown podio-dropdown-dropcontainer-wrapper ' + elmControlWrapper.attr("id") + '-ddw', id: elmControlWrapper.attr("id") + '-ddw'});
      elmWrapper.append(elmDropContainer);
      elmWrapper.insertAfter(elmControlWrapper);
      elmWrapper.isOpen = false;
      elmWrapper.hide();

      return elmWrapper;
    }

    function renderDropdownItems() {

      var elmOriginalOptions = elmHiddenInput.children();

      elmOriginalOptions.each(function(index) { // when the select has groups
        var elmItem = $(this);
        var mode = ''; // unused for now
        if (elmItem.is("option")) {
          addDropdownOption(elmItem, index, mode, false);
        } else if (elmItem.is("optgroup")) {
          renderDropdownGroup(elmItem, index, {
            mode : mode,
            icon :elmItem.attr("data-icon"),
            label: elmItem.attr("data-label")
          });
        }
      });

      if (settings.customOptions) {
        $.each(settings.customOptions, function() {
          var option = this;
          renderDropdownOption(option.text, option.id, option.id, 0, 0, {
            isMultiple: settings.isMultiple,
            isDisabled: false,
            isSelected: false,
            isIndented: false,
            mode: settings.itemModes.custom,
            prepend: option.prepend,
            icon: option.icon,
            insertIndex: option.insertIndex
          });
        });
      }

      if (settings.showAllOption) {
        var allOptionValue;

        /*        if(!settings.isMultiple) {
         allOptionValue = settings.singleAllOptionValue;
         // HACK: Need to add extra option to source select, otherwise I can't select the 'all' value.
         var elmOption = $('<option />', { value: settings.singleAllOptionValue, text: settings.showAllLabel });
         elmHiddenInput.prepend(elmOption);
         } else {
         allOptionValue = settings.showAllLabel
         }*/

        renderDropdownOption(settings.showAllLabel, allOptionValue, elmControlWrapper.attr("id") + '-all', 0, 0, {
          isMultiple: settings.isMultiple,
          isDisabled: false,
          isSelected: false,
          isIndented: false,
          mode: settings.itemModes.master,
          prepend: true
        });

        handleMasterState();
      }

    }

    function renderDropdownGroup(elmItem, parentIndex, options) {
      var isDisabled = elmItem.prop("disabled");

      var elmGroup = $("<div />", { 'class' : 'podio-dropdown-group'});
      if (isDisabled) {
        elmGroup.addClass("podio-dropdown-state-disabled");
      }

      var elmGroupLabel = $("<label />", { 'class' : 'podio-dropdown-text', text: elmItem.attr('label') });
      elmGroup.append(elmGroupLabel);
      if (options.icon) {
        var elmIcon = $("<span />", { 'class' : 'icon ' + options.icon});
        elmGroup.prepend(elmIcon);
        elmGroup.addClass('icon-enabled');
        elmGroup.attr('data-icon', options.icon);
      }

      if (options.label) {
        var elmLabel = $("<span />", { 'class' : 'label ', 'text': options.label});
        elmGroup.append(elmLabel);
        elmGroup.addClass('label-enabled');
        elmGroup.attr('data-label', options.label);
      }


      elmDropContainer.append(elmGroup);

      elmItem.children("option").each(function(index) {
        var elmOption = $(this), mode = '', childIndex = parentIndex + '.' + index;
        addDropdownOption(elmOption, childIndex, mode, true);
      });
    }

    function addDropdownOption(elmItem, index, mode, isIndented) {
      var text = elmItem.text();
      var value = elmItem.val();
      var isSelected = elmItem.prop('selected');
      var isDisabled = elmItem.prop("disabled");
      var icon = elmItem.attr("data-icon");
      var prefixLabel = elmItem.attr("data-prefix-label");
      var tabIndex = elmControlContainer.attr("tabindex");
      var idBase = elmControlWrapper.attr("id");

      renderDropdownOption(text, value, idBase, index, tabIndex, {
        isMultiple: settings.isMultiple,
        isDisabled: isDisabled,
        isSelected:  isSelected,
        isIndented: isIndented,
        mode:  mode,
        prepend: false,
        icon: icon,
        prefixLabel: prefixLabel
      });
    }

    function renderDropdownOption(text, value, idBase, index, tabIndex, options) {
      var inputType = options.isMultiple ? 'checkbox' : 'radio';
      var id = idBase + '-i' + index;
      var elmDropDownItem = $("<div />", { 'class' : 'podio-dropdown-item'});
      var checkedString = options.isSelected ? ' checked="checked"' : '';
      var classString = options.isDisabled ? 'inactive' : 'active';
      classString += ' ' + options.mode;

      var elmCheckbox = $('<input disabled type="' + inputType + '" index="' + index + '" name="' + idBase + '" id="' + id + '"' + checkedString + 'class="' + classString + '"' + ' tabindex="' + tabIndex + '" />');
      elmCheckbox.val(value).prop('checked', options.isSelected);

      var elmLabel = $("<label />", { 'for' : id , 'class' : 'podio-dropdown-text podio-dropdown-state-default', text: text });

      if (options.icon) {
        var elmIcon = $("<span />", { 'class' : 'icon ' + options.icon});
        elmDropDownItem.prepend(elmIcon);
        elmDropDownItem.addClass('icon-enabled');
        elmDropDownItem.attr('data-icon', options.icon);
      }

      if (options.prefixLabel) {
        var elmPrefixLabel = $("<span />", { 'class' : 'prefix-label', 'text' : options.prefixLabel});
        elmLabel.prepend(elmPrefixLabel);
      }

      elmDropDownItem.append(elmCheckbox);
      elmDropDownItem.append(elmLabel);
      elmDropDownItem.addClass(inputType);
      elmDropDownItem.attr('data-mode', options.mode);
      elmDropDownItem.attr('data-id', idBase);

      if (options.isIndented) {
        elmDropDownItem.addClass("podio-dropdown-indent");
      }

      if (options.isDisabled) {
        elmDropDownItem.addClass("podio-dropdown-state-disabled");
      }

      if (options.prepend) {
        if (options.insertIndex !== undefined) {
          var elmInsertTarget = elmDropContainer.children('.podio-dropdown-item').eq(options.insertIndex);
          elmDropDownItem.insertAfter(elmInsertTarget);
        } else {
          elmDropContainer.prepend(elmDropDownItem);
        }
      } else {
        elmDropContainer.append(elmDropDownItem);
      }

    }

    function selectCurrentDropdownItem() {
      elmSelectedDropdownItem = elmDropContainer.find('.' + settings.classes.item + ' input[value="' + elmHiddenInput.val() + '"]').parent();
      elmSelectedDropdownItem.addClass('active');
    }

    function resetCurrentDropdownItem() {
      elmDropContainer.find('.' + settings.classes.item).removeClass(settings.classes.itemActive);
      elmSelectedDropdownItem = null;
    }

    function updateControlIcon() {
      if (settings.isMultiple) {
        return;
      }

      var elmCheckedInput = elmDropContainer.find('input:checked');
      var elmParentItem = elmCheckedInput.parents('.podio-dropdown-item');
      var elmControlIcon = elmControlWrapper.find('.' + settings.classes.podioControlIcon);

      if (elmParentItem.hasClass('icon-enabled')) {
        if (!elmControlIcon.length) {
          elmControlIcon = $('<div />', { 'class' : settings.classes.podioControlIcon}).prependTo(elmControlWrapper.find('.podio-dropdown-selector'));
        }

        elmControlIcon.attr('class', settings.classes.podioControlIcon);
        elmControlIcon.addClass(elmParentItem.data('icon'));
      } else {
        elmControlIcon.remove();
      }

    }

    function updateControlText() {
      var elmOriginalOptions = elmHiddenInput.find("option");
      var elmDropdownInputs = elmDropContainer.find('input');

      var text = '';

      if ($.isFunction(settings.textFormatFunction)) {
        text = settings.textFormatFunction(elmOriginalOptions, elmDropdownInputs);
      } else {
        var elmSelectedItem = elmOriginalOptions.filter(':selected');
        if (!elmSelectedItem.length) {
          elmSelectedItem = elmOriginalOptions.first();
        }

        text = elmSelectedItem.text();
        if (text === '' && settings.emptyText) {
          text = settings.emptyText;
        }
      }

      var controlLabel = elmControlWrapper.find(".podio-dropdown-text");
      controlLabel.text(text);
      controlLabel.attr("title", text);
    }

    function updateDropdownHeight() {
      var dropContainerHeight = elmDropContainer.outerHeight();
      var dropHeight = dropContainerHeight;

      // the drop container height can be set from options
      var maxDropHeight = (settings.maxDropHeight !== null) ? parseInt(settings.maxDropHeight, 10) : -1;

      if ((maxDropHeight > 0) && (dropContainerHeight > maxDropHeight)) {
        elmDropWrapper.addClass('scrollbar');
        dropHeight = maxDropHeight;
      }

      elmDropWrapper.css({ height: dropHeight + "px" });
      elmDropContainer.css({ height: dropHeight + "px"});
    }

    function showDropdown() {
      if (elmDropWrapper.is(':visible')) {
        return;
      }

      hideOtherDropdowns();

      elmDropWrapper.show();
      elmDropWrapper.one('outsideclick', onOutsideClick);

      if (!hasAdjustedDropdownHeight) {
        // set the sizes of control and drop container;
        updateDropdownHeight();
        hasAdjustedDropdownHeight = true;
      }

      elmControlContainer.addClass("podio-dropdown-state-active");
      elmControlContainer.removeClass("podio-dropdown-state-hover");

      // insert the items back into the tab order by enabling all active ones
      elmDropWrapper.find("input.active").prop('disabled', false);

      elmDropContainer.scrollTop(0);

      adjustDropdownItemsWidth();

      elmHiddenInput.trigger(settings.events.show);
    }

    function hideOtherDropdowns() {
      $('.podio-dropdown-dropcontainer-wrapper').not(elmDropWrapper).trigger(settings.events._internal_forceHide);
    }

    function hideDropdown() {
      if (!elmDropWrapper.is(':visible')) {
        return;
      }

      elmDropWrapper.hide();

      elmControlContainer.removeClass("podio-dropdown-state-active");
      elmControlContainer.removeClass("podio-dropdown-state-hover");

      // keep the items out of the tab order by disabling them
      elmDropWrapper.find("input.active").prop("disabled", true);

      elmHiddenInput.trigger(settings.events.hide);
    }

    function adjustDropdownItemsWidth() {
      // Adjust label width due to variable scrollbar width;
      if (!hasAdjustedLabelWidth) {
        var elmDropDownItems = elmDropWrapper.find('.podio-dropdown-item');
        var elmFirstItem = elmDropDownItems.first();
        var labelWidth = elmFirstItem.outerWidth(true) - scrollbarWidth;

        // fix for the iPad
        if (scrollbarWidth < 1) {
          labelWidth -= 15;
        }

        if (!elmFirstItem.find('input[type=radio]').length) { // we show the checkbox, subtract width
          labelWidth = labelWidth - elmFirstItem.find('input').outerWidth(true);
        }

        if (elmFirstItem.hasClass('icon-enabled')) {
          labelWidth = labelWidth - elmFirstItem.find('.icon').outerWidth(true);
        }

        elmDropDownItems.each(function() {
          $(this).find('label').width(labelWidth);
        });

        hasAdjustedLabelWidth = true;
      }
    }

    function syncDropdownToInput() {
      var notSelector;
      if (settings.isMultiple) {
        notSelector = ':not(.' + settings.itemModes.custom + ')';
      } else {
        notSelector = ':not(.' + settings.itemModes.master + ' ,.' + settings.itemModes.custom + ')';
      }

      var selectOptions = elmHiddenInput.find('option');
      var elmCheckedNonMasterBoxes = elmDropWrapper.find("input.active").filter(notSelector);

      elmCheckedNonMasterBoxes.each(function(index) {
        var elmInput = $(this);
        var inputValue = elmInput.val();
        var isInputChecked = elmInput.is(":checked");

        for (var i = 0, len = selectOptions.length; i < len; i++) {
          var domOption = selectOptions[i];
          if ($(domOption).val() == inputValue) {
            domOption.selected = isInputChecked;
            break;
          }
        }

      });
    }

    function syncInputToDropdown() {
      var notSelector;
      if (settings.isMultiple) {
        notSelector = ':not(.' + settings.itemModes.custom + ')';
      } else {
        notSelector = ':not(.' + settings.itemModes.master + ' ,.' + settings.itemModes.custom + ')';
      }

      var elmCheckedNonMasterBoxes = elmDropWrapper.find("input.active").filter(notSelector);
      var selectOptions = elmHiddenInput.find('option');
      selectOptions.each(function(index) {
        var elmOption = $(this);
        var optionValue = elmOption.val();

        for (var i = 0, len = elmCheckedNonMasterBoxes.length; i < len; i++) {
          var domInput = elmCheckedNonMasterBoxes[i];
          var elmInput = $(domInput);
          if (domInput.value == optionValue) {
            elmInput.prop("checked", elmOption.prop("selected"));
            break;
          }
        }


      });

      handleMasterState();
      updateControlText();
    }

    function onOutsideClick(e) {
      hideDropdown();
    }

    exports = {
      init : init,
      val: function(value) {
        if (!arguments.length) {
          return elmHiddenInput.val();
        } else {
          elmHiddenInput.val(value);
          onRefreshEvent();
          return elmHiddenInput;
        }
      }
    };

    // Public methods
    return exports;
  };

  $.fn.podioDropdown = function (methodOrSettings) {
    var outerArguments = arguments, returnValue;

    this.each(function () {
      var instance = $.data(this, 'podioDropdown') || $.data(this, 'podioDropdown', new $.podioDropdown(this));

      if (_.isFunction(instance[methodOrSettings])) {
        returnValue = instance[methodOrSettings].apply(this, Array.prototype.slice.call(outerArguments, 1));

      } else if (typeof methodOrSettings === 'object' || ! methodOrSettings) {
        var passedSettings = methodOrSettings || {};
        var defaultSettings = getDefaultSettings();
        var settings = $.extend(true, {}, defaultSettings, passedSettings);
        settings.dropdownId = Math.floor(Math.random() * 1000);

        returnValue = instance.init.call(this, settings);

      } else {
        $.error('Method ' + methodOrSettings + ' does not exist');
      }
    });

    return returnValue || this;
  };


});

